import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence debug logging in production builds (console.error/warn kept for diagnostics)
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

// Optional Sentry init — no-op when REACT_APP_SENTRY_DSN is not set.
// Wrapped in try/catch so a missing dep never breaks the prod bundle.
(async () => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;
  try {
    const Sentry = await import(/* webpackIgnore: true */ '@sentry/react');
    Sentry.init({
      dsn,
      environment: process.env.REACT_APP_ENV || 'production',
      tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.05'),
      ignoreErrors: ['ResizeObserver loop limit exceeded', 'Network Error'],
    });
  } catch { /* @sentry/react not installed — no-op */ }
})();

// Remove platform-injected branding
(function(){var r=function(){var e=document.getElementById('emergent-' + 'badge');if(e)e.parentNode.removeChild(e)};r();if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',r)}else{r()}setInterval(r,300)})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
